import { ClientServiceProvider } from '../../../clients/services/client-service/client-service';
import { Component, OnDestroy, ViewChild } from '@angular/core';
import { ConfigServiceProvider } from '../../../core/services/config-service/config-service';
import { FormField } from '../../../../submodules/sellions_forms/projects/forms/src/lib/interfaces/form-field.interface';
import { FormGroup } from '@angular/forms';
import { IonicPage, NavParams, ViewController } from 'ionic-angular';
import { ProductServiceProvider } from '../../services/product-service';
import { ProjectMarketsServiceProvider } from '../../services/project-markets.service';
import { ProjectService } from '../../services/project.service';
import { SellionsFormsRendererComponent } from '../../../../submodules/sellions_forms/projects/forms/src/public-api';
import { Subscription } from 'rxjs';
import { TextServiceProvider } from '../../../core/services/text-service/text-service';

@IonicPage()
@Component({
  selector: 'page-project-modify',
  templateUrl: 'project-modify.html',
})
export class ProjectModifyPage implements OnDestroy {
  @ViewChild(SellionsFormsRendererComponent)
  formRenderer: SellionsFormsRendererComponent;

  public form: FormField[] = [];
  public value: FormGroup = new FormGroup({});
  public project: any;
  public marketIds: Array<string>;
  private clients: any[] = [];
  private clientsSubscription: Subscription;

  constructor(
    private projectService: ProjectService,
    private productService: ProductServiceProvider,
    private clientService: ClientServiceProvider,
    private projectMarketsService: ProjectMarketsServiceProvider,
    private navParams: NavParams,
    private viewCtrl: ViewController,
    public config: ConfigServiceProvider,
    public textService: TextServiceProvider,
  ) {}

  ionViewWillEnter() {
    this.project = this.navParams.get('project');
    this.projectService
      .getModifyFormDefinition()
      .then((form: FormField[]) => {
        this.fillFormWithPredefinedValues(form);
        this.form = form;
      })
      .catch((error) => console.error(error));
    this.marketIds = this.project.markets.map((market) => market.name);
  }

  onReferencesChange($event) {
    this.clients = $event.client;
  }

  ngOnDestroy(): void {
    this.unsubscribeClientsFilters();
    this.productService.unsubscribe();
    this.projectMarketsService.unsubscribeProjectMarkets();
  }

  unsubscribeClientsFilters() {
    if (this.clientsSubscription) {
      this.clientsSubscription.unsubscribe();
    }
  }

  onFieldsManagementFinished() {
    setTimeout(() => this.productService.toggleCementDisplay(this.formRenderer.form.controls['product']), 0);
    this.watchChanges();
  }

  watchChanges() {
    this.watchClients();
    this.productService.watchProduct(this.formRenderer.form.controls['product']);
  }

  private fillFormWithPredefinedValues(form: FormField[]) {
    const projectField = form.find((field) => field.id === 'project');
    projectField.predefinedValue = this.project.id;

    const nameField = form.find((field) => field.id === 'name');
    nameField.predefinedValue = this.project.project_name;

    const descriptionField = form.find((field) => field.id === 'description');
    descriptionField.predefinedValue = this.project.description;

    const investorField = form.find((field) => field.id === 'investor');
    investorField.predefinedValue = this.project.investor;

    const startDateField = form.find((field) => field.id === 'startDate');
    startDateField.predefinedValue = this.project.start_date;

    const endDateField = form.find((field) => field.id === 'endDate');
    endDateField.predefinedValue = this.project.end_date;

    const localityField = form.find((field) => field.id === 'locality');
    localityField.predefinedValue = this.project.locality;

    const statusField = form.find((field) => field.id === 'status');
    statusField.predefinedValue = this.project.status;

    const typeField = form.find((field) => field.id === 'projectType');
    typeField.predefinedValue = this.project.project_type;

    const clientsSubform = form.find((field) => field.id === 'clients');
    clientsSubform.predefinedValue = [];
    this.project.clients.forEach((client) => {
      clientsSubform.predefinedValue.push({ client });
    });

    const productSubform = form.find((field) => field.id === 'product');
    const productNameField = productSubform.subForm.definition.find((field) => field.id === 'name');
    productNameField.predefinedValue = this.project.product.name;
    const volumeField = productSubform.subForm.definition.find((field) => field.id === 'volume');
    volumeField.predefinedValue = this.project.product.volume;
    const unitField = productSubform.subForm.definition.find((field) => field.id === 'unit');
    unitField.predefinedValue = this.project.product.unit;
  }

  assignValue(value: FormGroup) {
    this.value = value;
  }

  save() {
    this.viewCtrl.dismiss(this.value.getRawValue()).catch((err) => console.error(err));
  }

  close() {
    this.viewCtrl.dismiss().catch((err) => console.error(err));
  }

  private watchClients() {
    if (!this.formRenderer.form || !this.formRenderer.form.controls['clients']) return;
    if (!this.clientsSubscription) {
      this.clientsSubscription = this.formRenderer.form.controls['clients'].valueChanges.subscribe((clients) => {
        clients.forEach((client: { client: string }, i: string) => {
          if (typeof client.client === 'string') {
            this.filterClients(client.client ? client.client.trim() : '', 'client' + i);
          } else {
            this.filterClients('', 'client' + i);
          }
        });
      });
    }

    this.marketIds = this.projectMarketsService.watchMarkets(this.formRenderer.form.controls['clients'], this.marketIds);
  }

  private filterClients(searchQuery: string, id: string) {
    this.formRenderer.references[id] = this.clients.filter((client) => this.clientService.checkAgainstClient(client, searchQuery));
  }
}



// WEBPACK FOOTER //
// ./src/modules/projects/pages/project-modify/project-modify.ts